import { createGenericReducer } from "common/genericReducer";
import { combineReducers } from "redux";
import {
  CONFIRM_DELETE_ACCOUNT_RECEIVED,
  CONFIRM_DELETE_ACCOUNT_REQUESTED,
  CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED,
  DELETE_ACCOUNT_RECEIVED,
  DELETE_ACCOUNT_REQUESTED,
  DELETE_ACCOUNT_REQUEST_FAILED,
  DELETE_ACCOUNT_REQUEST_RESET
} from "./deleteAccountActions";

const createDeleteAccountReducer = () => {
  return createGenericReducer(
    DELETE_ACCOUNT_REQUESTED,
    DELETE_ACCOUNT_RECEIVED,
    DELETE_ACCOUNT_REQUEST_FAILED,
    DELETE_ACCOUNT_REQUEST_RESET
  );
};

const createConfirmDeleteAccountReducer = () => {
  return createGenericReducer(
    CONFIRM_DELETE_ACCOUNT_REQUESTED,
    CONFIRM_DELETE_ACCOUNT_RECEIVED,
    CONFIRM_DELETE_ACCOUNT_REQUEST_FAILED
  );
};

export const deleteAccount = combineReducers({
  deleteAccountRequest: createDeleteAccountReducer(),
  deleteAccountConfirmation: createConfirmDeleteAccountReducer()
});
